import { Grid, TablePagination } from "@mui/material";
import { observer } from "mobx-react";
import ChartCardStore from "../ChartCardStore";

const ChartPagination = observer(({ store }: { store: ChartCardStore }) => {
    return (
        <Grid
            item
            container
            justifyContent="flex-end"
            className="no-export" // prevent element from showing up in export to png
        >
            <TablePagination
                component="div"
                count={store.totalItems}
                page={Math.min(store.currentPage, store.maxPage)}
                onPageChange={(e, page) => {
                    if (page !== store.currentPage) {
                        store.setPage(page);
                    }
                }}
                rowsPerPage={store.pageSize}
                rowsPerPageOptions={[store.pageSize]}
                showFirstButton
                showLastButton
            />
        </Grid>
    );
});

export default ChartPagination;
